<template>
  <transition name="fade">
    <div class="tcourse-term-row">
      <div class="date">
        <div class="date-box online">
          <img :src="icon" :alt="$t('online_course')">
          <strong>
            {{ $t('online_course') }}
          </strong>
        </div>
      </div>
      <div class="place">
        <div class="dates__label">
          {{ $t('place') }}
        </div>
        <span>
          {{ $t('online') }}
        </span>
      </div>
      <div class="duration">
        <div class="dates__label">
          {{ $t('duration') }}
        </div>
        {{ duration }}
      </div>
      <div class="capacity">
        <div class="dates__label">
          {{ $t('capacity') }}
        </div>
        <small>{{ capacity }}</small>
      </div>
      <div class="lang">
        <div class="dates__label">
          {{ $t('language') }}
        </div>
        {{ $t(`language_translation.${language}`) }}
      </div>
      <div class="original-price">
        <template v-if="!isFree">
          <div class="dates__label">
            {{ $t('original_price') }}
          </div>
          <strike>{{ priceOldInCurrency | currency(activeCurrency) }}</strike>
        </template>
      </div>
      <div class="price">
        <div class="dates__label">
          {{ $t('price_without_vat') }}
        </div>
        <div class="dates__text dates__text--price">
          <template v-if="isFree">
            {{ $t('free_price') }}
          </template>
          <template v-else>
            {{ priceInCurrency | currency(activeCurrency) }}
          </template>
        </div>
      </div>
      <div class="order">
        <a class="btn-red" :href="orderLink">{{ $t('i_am_interested') }}</a>
        <br>
        <div class="installments">
          <a :href="repaymentsLink">{{ $t('repayments') }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import priceMixin from '../lib/priceMixin';

export default {
  mixins: [priceMixin],
  name: 'Online',
  props: ['capacity', 'duration', 'id', 'icon', 'language', 'price', 'price_eur', 'price_eur_old', 'price_old'],
  computed: {
    orderPath() {
      return this.$i18n.locale !== 'en' ? 'objednavky' : 'en/orders';
    },
    orderLink() {
      return `/${this.orderPath}/set_event_session?event_id=${this.id}`;
    },
    repaymentsLink() {
      return `/${this.orderPath}/set_event_session?event_id=${this.id}&repayments=true`;
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<i18n>
{
  "cs": {
    "course": "Kurz",
    "online_course": "Online kurz",
    "capacity": "Kapacita",
    "original_price": "Cena před slevou",
    "online": "e-Learning",
    "or": "nebo",
    "duration": "Délka",
    "days_duration": ["den", "dny", "dní"],
    "i_am_interested": "Mám zájem",
    "language": "Jazyk",
    "language_translation": {
      "cs": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    },
    "place": "Místo",
    "price_without_vat": "Cena bez DPH",
    "free_price": "ZDARMA",
    "repayments": "S odloženou splatností",
    "term": "Termín"
  },
  "sk": {
    "course": "Kurz",
    "online": "Online",
    "online_course": "Online kurz",
    "original_price": "Cena před slevou",
    "capacity": "Kapacita",
    "or": "alebo",
    "duration": "Dĺžka",
    "days_duration": ["deň", "dni", "dní"],
    "i_am_interested": "Mám záujem",
    "language": "Jazyk",
    "language_translation": {
      "cs": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    },
    "place": "Miesto",
    "price_without_vat": "Cena bez DPH",
    "free_price": "ZADARMO",
    "repayments": "Žiadosť o odloženie splatnosti",
    "term": "Termín"
  },
  "en": {
    "course": "Course",
    "online": "Online",
    "original_price": "Original price",
    "capacity": "Capacity",
    "online_course": "Online course",
    "or": "or",
    "duration": "Duration",
    "days_duration": ["day", "days", "days"],
    "i_am_interested": "Book",
    "language": "Language",
    "language_translation": {
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak"
    },
    "place": "Location",
    "price_without_vat": "Price without VAT",
    "free_price": "FREE",
    "repayments": "Pay Later",
    "term": "Date"
  }
}
</i18n>
